export default "__VITE_ASSET__CTWcxcQ2__"